module.exports = __webpack_public_path__ + "img/artillery-wagon-base-4.26ce6359.png";